import { CSVProfile, CSVTranformationProfile } from '../../types'
import { MwChartWordCloudChartOptions, SeriesData } from '@meltwater/mw-visualizations-angularjs'

import { BaseVisualization } from '../base/base-visualization-component'
import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import { ExportToCsv } from '../utils/csv-export-utils'

export class WordCloudLoopComponent extends BaseVisualization {
    static config = {
        selector: 'wordCloudLoopComponent',
        controller: WordCloudLoopComponent,
        template: `
            <div layout="row" layout-sm="column" layout-wrap>
            <div ng-repeat="visualization in $ctrl.visualizationList" flex-xl="50" flex-lg="50" flex-md="100" flex-sm="100" flex-xs="100" class="inner-vis">
            <md-card
            trigger-update="$ctrl.onUpdate" viz-data="$ctrl.vizData"
            >
                <mw-toolbar is-transparent="true">
                    <mw-toolbar-title class="md-truncate">
                        <span translate>explore__visualizations--top-keywords-for</span> {{visualization.title}}
                    </mw-toolbar-title>
                    <div flex></div>
                    <md-menu ng-if="!$ctrl.isLoading && !$ctrl.isError || $ctrl.properties.isMenuButton" class="mw-menu" md-position-mode="target-right target" md-offset="0 52">
                        <mw-menu-trigger-icon-button icon="navigation:ic_more_vert_24px" tooltip="{{'Open Menu' | translate}}" on-click="$mdMenu.open($event)">
                        </mw-menu-trigger-icon-button>
                            <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                                <mw-menu-item ng-if="$ctrl.properties.isCSVExport" icon="ic_get_app_24px" aria-label="Download CSV" on-click="$ctrl.exportCSV()">Download CSV</mw-menu-item>
                            </md-menu-content>
                    </md-menu>
                </mw-toolbar>

                <div class="af__chart__container af__{{visualization.size}} wc-loop" layout="row" layout-wrap>

                    <div class="dc" ng-if="($ctrl.vizData) || ($ctrl.isLoading) || $ctlr.isError" >
                    <div class="af__loader__container" ng-if="$ctrl.isLoading">
                        <mw-loader></mw-loader>
                    </div>
                        <mw-chart-word-cloud
                            ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty(visualization) && visualization.visualizationOptions"
                            chart-data="visualization.visualizationData"
                            chart-options="visualization.visualizationOptions"
                            get-api="$ctrl.getApi(API)">
                        </mw-chart-word-cloud>
                    </div>

                    <error-widget
                        ng-if="!$ctrl.isLoading && $ctrl.isObjEmpty($ctrl.vizData)"
                        zero-data="!$ctrl.isLoading && ($ctrl.isObjEmpty($ctrl.spline) && $ctrl.isObjEmpty($ctrl.donut)) && !$ctrl.isObjEmpty($ctrl.vizData)"
                        error-data="(!$ctrl.isLoading && $ctrl.isObjEmpty($ctrl.vizData)) || $ctrl.isError">
                    </error-widget>

                </div>
                </div>
            </md-card>
            </div>
        `,
        bindings: BaseVisualization.config.bindings,
    }

    /**
     * Default chart properties
     */
    public seriesTitle: string = 'Occurences'
    public seriesColors: [string]
    public maxPhraseLength: number = 20

    /**
     * List of chart data & option
     */
    public visualizationList = []

    // default CSV header columns. Can be overriden in sub class.
    public csvHeaders = ['Keyword/Phrase', this.seriesTitle]
    public transformationProfiles: CSVTranformationProfile[] = []

    // temp workaround for csv export.
    // Need to find a better way.
    public csvExporter: ExportToCsv = new ExportToCsv();

    $onInit() { }
    $onChanges(changes) {
        if (this.hasChanges(changes.visualizationMetaData) && this.isLoading) {
            this.prepareLoadingVisualizations(changes.visualizationMetaData.currentValue)
            this.setMetaData(changes.visualizationMetaData.currentValue)
        }
        if (this.hasChanges(changes.vizData)) {
            this.setProperties()
            this.prepareVisualizations(changes.vizData.currentValue)
            this.buildCSVExportProfile()
        }
    }

    setProperties() { }

    /**
     * Creates the multi chart component data to be displayed.
     * @param payload strutured data object response recieved for multiple donut chart
     * @see API [View Request Documentation](https://explore-api.dev.alphaflight.meltwater.io/swagger-ui.html#)
     */
    prepareVisualizations(payload) {
        this.visualizationList = []
        let data = this.sortCompareLoop(
            this.namingUtils.returnData(payload.data),
            'key',
            this.visualizationMetaData
        )

        data.forEach((element, idx) => {
            this.visualizationList.push({
                title: element.key,
                size: 'medium',
                visualizationData: this.getVisualizationData(element),
                visualizationOptions: this.getVisualizationOptions(idx),
            })
        })
    }

    prepareLoadingVisualizations(metaData) {
        this.visualizationList = []
        let data = metaData

        data.forEach(element => {
            this.visualizationList.push({
                title: element.name,
                size: 'medium',
            })
        })
    }

    getVisualizationData(element) {
        return new SeriesData({
            name: this.seriesTitle,
            data: element.value,
        })
    }

    getVisualizationOptions = idx => {
        return new MwChartWordCloudChartOptions({
            seriesColor: this.seriesColors[idx],
            onPointClick: this.onPointClick,
            tooltipFormatter: this.tooltipFormatter,
            maxPhraseLength: this.maxPhraseLength,
        })
    }

    onPointClick = event => {
        this.triggerUpdate(this.updatePayload('FILTER_CHANGE', 'append', 'subKeyword', event.key))
    }

    tooltipFormatter = point => {
        return `${point.key}<br><strong>${this.seriesTitle}:</strong> ${point.value}`
    }

    buildCSVExportProfile() {
        this.csvExportProfiles = []

        let exportData: CSVProfile = {
            data: Object.assign({}, this.vizData.data),
            csvOptions: { title: this.visTitle, headers: this.csvHeaders },
            transformationProfiles: this.transformationProfiles,
        }

        this.csvExportProfiles.push(exportData)
    }

    exportCSV() {
        this.csvExporter.export(this.csvExportProfiles)
    }
}
